import { render, staticRenderFns } from "./User_management.vue?vue&type=template&id=08aed1b4&style=height%3A100%25"
import script from "./User_management.vue?vue&type=script&lang=js"
export * from "./User_management.vue?vue&type=script&lang=js"
import style0 from "./User_management.vue?vue&type=style&index=0&id=08aed1b4&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports